import React from 'react';
import { useSearchParams } from 'react-router-dom';

const RewardShareCard = () => {
  const [searchParams] = useSearchParams();
  const amountParam = searchParams.get('amount');
  const parsedRewardAmount = Number(amountParam);
  const rewardAmount = Number.isFinite(parsedRewardAmount) && parsedRewardAmount >= 0
    ? parsedRewardAmount
    : 0;
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';
  const [shareMessage, setShareMessage] = React.useState('');

  const handleShare = async () => {
    const shareText = `I just earned ₹${rewardAmount} in TrustApp rewards. Check my reward card: ${shareUrl}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'TrustApp Rewards',
          text: shareText,
          url: shareUrl,
        });
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.warn('Native sharing failed; trying to copy the reward card link.', error);
      }
    }

    try {
      await navigator.clipboard.writeText(shareText);
      setShareMessage('Reward card link copied. Paste it into Instagram or another app to share.');
    } catch (error) {
      console.error('Failed to copy reward card link:', error);
      setShareMessage('Copy failed. Please copy the reward card link from your browser address bar.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fef3c7 0%, #f59e0b 35%, #7c3aed 100%)',
      padding: '24px',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        background: 'rgba(255,255,255,0.96)',
        borderRadius: '24px',
        padding: '28px 22px',
        boxShadow: '0 18px 45px rgba(0,0,0,0.18)',
        border: '1px solid rgba(255,255,255,0.7)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <div style={{
            display: 'inline-flex',
            width: '68px',
            height: '68px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #fef3c7, #f59e0b)',
            color: '#78350f',
            fontSize: '2.2rem',
            fontWeight: '800',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 18px rgba(245, 158, 11, 0.25)',
          }}>₹</div>
          <p style={{ margin: '14px 0 8px', fontSize: '0.8rem', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700' }}>
            TrustApp Rewards
          </p>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)',
          borderRadius: '22px',
          padding: '26px 18px',
          color: '#fff',
          textAlign: 'center',
          marginBottom: '18px',
          boxShadow: 'inset 0 0 20px rgba(255,255,255,0.08)',
        }}>
          <div style={{ fontSize: '0.8rem', opacity: 0.9, letterSpacing: '1px', textTransform: 'uppercase' }}>
            I earned
          </div>
          <div style={{ fontSize: '3rem', fontWeight: '900', lineHeight: 1.1, margin: '10px 0 0' }}>
            ₹{rewardAmount}
          </div>
          <div style={{ fontSize: '0.92rem', marginTop: '10px', opacity: 0.95 }}>
            in TrustApp rewards
          </div>
        </div>

        <p style={{
          textAlign: 'center',
          fontSize: '0.92rem',
          lineHeight: 1.6,
          color: '#334155',
          margin: '0 0 20px',
        }}>
          I’ve collected my TrustApp reward. Share this reward card to show others I’ve earned it.
        </p>

        <button
          onClick={handleShare}
          style={{
            width: '100%',
            border: 'none',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: '700',
            padding: '14px 18px',
            cursor: 'pointer',
            boxShadow: '0 10px 20px rgba(37, 99, 235, 0.25)',
          }}
        >
          Share reward card
        </button>
        {shareMessage && (
          <p role="status" style={{ margin: '12px 0 0', textAlign: 'center', fontSize: '0.82rem', color: '#475569' }}>
            {shareMessage}
          </p>
        )}

        <p style={{
          marginTop: '16px',
          textAlign: 'center',
          fontSize: '0.78rem',
          color: '#64748b',
          wordBreak: 'break-all',
        }}>
          {shareUrl}
        </p>
      </div>
    </div>
  );
};

export default RewardShareCard;
